import { useState, useEffect, useRef, useContext, useMemo } from "react";
import "./Detailsabha.css";
import Loader from "../../../components/Loader";
import { sickleAPI } from "../../../services/sickle.api";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { NcdForm } from "../../ncd/components/NcdForm";
import { SickleRegistration } from "../../sickle/components/SickleRegistration";
import { Faimily } from "../../ncd/components/Faimily";
import Addmember from "../../ncd/components/familyfolder/Addmember";
import CBACform from "../../ncd/components/CBACform";
import { InitialAssessmentForm } from "../../ncd/components/initialassessment";
import { HypertensionFollowup } from "../../ncd/components/HypertensionFollowup";
import { DiabetesFollowup } from "../../ncd/components/DiabetesFollowup";
import { OralScreening } from "../../ncd/components/OralcancerFollowup/OralScreening";
import { BreastScreening } from "../../ncd/components/BreastcancerFollowup/BreastScreening";
import { CervicalScreening } from "../../ncd/components/CervicalcancerFollowup/CervicalScreening";
import { Investigation } from "../../ncd/components/Investigation";
import { General } from "../../ncd/components/General";
import { Sickle } from "../../sickle/components/Sickle";
import {
    Sickleform,
    handleGetRefreshToken,
    handlePatientTestDetails,
} from "../../sickle/components/Sickleform";
import { FollowupTreatment } from "../../ncd/components/FollowupTreatment";
import useVisibility from "../../../components/useVisibility";
import { VIEWCONSTANT } from "../../../AppConstant/ViewConstant";
import { toast } from "react-toastify";
import { ncdAPI } from "../../../services/ncd.api";
import { nikshayAPI } from "../../../services/nikshay.api";
import { uwinAPI } from "../../../services/uwin.api";
import { pmndpAPI } from "../../../services/pmndp.api";
import SickleMainModel from "../../sickle/components/SickleMainModel";
import PMNDPMaineModel from "../../pmndp/components/PMNDP-main-model";
import DialysisHistory from "../../pmndp/components/dialysis-history";
import PMNDPRegistrationForm from "../../pmndp/components/PMNDP-registrationForm";
import AddPatentsModel from "../../pmndp/components/SloatManagement";
import SickleMedication from "../../sickle/components/SickleMedication";
import DiseaseManagement from "../../sickle/components/DiseaseManagement";
import NewRegistrationNikshay from "../../nikshay/components/New-Registration";
import Nikshaymainmodal from "../../nikshay/components/Nikshay_Main_Modal";
import UwinPage from "../../uwin/pages/UwinMainPage";
import { Uwinmainmodal } from "../../uwin/components/Uwin-main-modal";
import { Vaccinationuwin } from "../../uwin/components/Vaccinationuwin";
import { Linkedchildren } from "../../uwin/components/Linkedchildren";
import Timeline from "../components/Timeline";
import RegistrationView from "../../nikshay/components/RegistrationView";
import { rchAPI } from "../../../services/rch.api";
import RCHRegistration from "../../RCH/RCHRegistration";
import RCHRegistrationPreview from "../../RCH/RCHRegistrationPreview";
import { checkUserLoginForProgram } from "../../../utils/authUtils";
import LoginRequiredModal from "../../../components/LoginRequiredModal";
import NikshayTest from "../../nikshay/components/NikshayTest";
import { hasPermission, getNcdPermissions } from "../../../utils/permissionHelper";
import { setError, setLoading } from "../../ncd/ncdSlice";
import { autoPopulateForm, getLatestFieldValue } from "../../../utils/fieldValueResolver";
import { CommonContext } from "../../../context/CommonContext";
import { formatDateAge, calculateAge } from "../../../helpers/common-helper";
import { Tabs, Tab, Box, Button } from "@mui/material";


export const Detailsabha = () => {
    const { fieldValues, updateFieldValues } = useContext(CommonContext);
    const { isHidden, showSection, hideSection } = useVisibility({
        NCDScreening: true,
        CBACKform: true,
        Followptreatment: true,
        FamilyForm: true,
    });

    const [profileData, setprofileData] = useState(null);
    const [individualId, setIndividualId] = useState("");
    const [familyInfo, setFamilyInfo] = useState("");
    const [famIndividualInfo, setFamIndividualInfo] = useState("");
    const [age, setAge] = useState(null); // State for calculated age
    const [showSickleModal, setShowSickleModal] = useState(false);
    const [propSickleCheckBox, setPropSickleCheckBox] = useState(false);
    const [patientTestDetails, setPatientTestDetails] = useState([]);
    const [SickleNextLoading, setSickleNextLoading] = useState(false);
    const [ShowSickleReg, setShowSickleReg] = useState(false);
    const [sickleId, setsickleId] = useState("");
    const [DiseaseType, setDiseaseType] = useState("");
    const [testType, setTestType] = useState("");
    const [SickleAbhaAvailabilityData, setSickleAbhaAvailabilityData] = useState(null);
    const targetRef = useRef(null);
    const [showSickleForm, setShowSickleForm] = useState(false);
    const [showCBACform, setshowCBACform] = useState(false);
    const [htnScreenId, setHtnScreenId] = useState(null);
    const [diabScreenId, setDiabScreenId] = useState(null);
    const [cervicalScreeningId, setCervicalScreenId] = useState(null);
    const [oralScreeningId, setOralScreeningId] = useState(null);
    const [breastScreeningId, setBreastScreeningId] = useState(null);
    const [generalScreeningId, setGeneralScreeningId] = useState(null);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showPMNDPMainModel, setShowPMNDPMainModel] = useState(false);
    const [parsedBeneficiary, setParsedBeneficiary] = useState(null);
    const [activePrograms, setActivePrograms] = useState(null);
    const [showModals, setShowModals] = useState(false);
    const [showPmndpActions, setShowPmndpActions] = useState(null);
    const [ShowSickleActions, setShowSickleActions] = useState(null);
    const [slotModel, setSlotModel] = useState(null);
    const [showNikshayMainModel, setShowNikshayMainModel] = useState(false);
    const [showNikshayActions, setShowNikshayActions] = useState(false);
    const [nikshayInitialTab, setNikshayInitialTab] = useState("details");
    const [showUwinReg, setShowUwinReg] = useState(false);
    const [showUwinAction, setshowUwinAction] = useState(null);
    const [showUwinMainModal, setShowUwinMainModal] = useState(false);
    const [benProfileData, setBenProfileData] = useState(false);
    const [loadedPrograms, setLoadedPrograms] = useState({});
    const [nikshayProfileData, setNikshayProfileData] = useState(null);
    const [nikshayView, setNikshayView] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [nikshayPatientExists, setNikshayPatientExists] = useState(null);
    const [isCbacComplete, setIsCbacComplete] = useState(false);
    const [showRchReg, setShowRchReg] = useState(false);
    const [showRchPreview, setShowRchPreview] = useState(false);
    const [rchBeneficiaryData, setRchBeneficiaryData] = useState(null);
    const [jananiSearchSuccess, setJananiSearchSuccess] = useState(false);

    const { hasAccess, permissions } = getNcdPermissions();

    const [showMoModal, setShowMoModal] = useState(false);
    const [activeAssessmentTab, setActiveAssessmentTab] = useState("initialassessment");
    const [hasAssessmentStarted, setHasAssessmentStarted] = useState(false);
    const ncdRole = localStorage.getItem("NCD_loggedinUserdetails");
    const ncdRoleData = useMemo(() => ncdRole ? JSON.parse(ncdRole) : null, [ncdRole]);

    const isMoOrStaffNurse = ncdRoleData && (ncdRoleData.rolename === 'MO' || ncdRoleData.rolename === 'STAFF_NURSE');

    const [ncdScreenDetails, setncdScreenDetails] = useState(null);

    const [showHtnPlus, setShowHtnPlus] = useState(false);
    const [showDiabetesPlus, setShowDiabetesPlus] = useState(false);
    const [showCervicalPlus, setShowCervicalPlus] = useState(false);
    const [showOralPlus, setShowOralPlus] = useState(false);
    const [showBreastPlus, setShowBreastPlus] = useState(false);
    const [showGeneralPlus, setShowGeneralPlus] = useState(false);

    useEffect(() => {
        setShowHtnPlus(!htnScreenId);
        setShowDiabetesPlus(!diabScreenId);
        setShowCervicalPlus(!cervicalScreeningId);
        setShowOralPlus(!oralScreeningId);
        setShowBreastPlus(!breastScreeningId);
        setShowGeneralPlus(!generalScreeningId);
    }, [htnScreenId, diabScreenId, cervicalScreeningId, oralScreeningId, breastScreeningId, generalScreeningId]);

    const [programs, setprograms] = useState({
        ncd: "",
        SCD: "",
        nikshay: "",
        JANANI: "",
        UWIN: "",
        IHIP: "",
        STATEAPP: "",
        PMNDP: "",
    });

    const beneficiaryDetails = localStorage.getItem("beneficiaryDetails");
    const orignalBeneficiaryData = localStorage.getItem("orignalBeneficiaryData");
    const ncdToken = localStorage.getItem("NCD_token");
    const sickleToken = localStorage.getItem("sickle_token");
    const PMNDP_token = localStorage.getItem("PMNDP_token");
    const Uwin_token = localStorage.getItem("uwin_token");
    const JANANI_token = localStorage.getItem("JANANI_token");
    const nikshay_token = localStorage.getItem("NIKSHAY_valid_user");
    const RBSK_token = localStorage.getItem("RBSK_token");

    const navigate = useNavigate(); // React Router hook for navigation

    // 1. Check token on mount

    useEffect(() => {
        const tokens = [
            ncdToken,
            sickleToken,
            PMNDP_token,
            nikshay_token,
            Uwin_token,
            JANANI_token,
            RBSK_token
        ];

        // Check if at least one valid token exists
        const hasValid = tokens.some(
            (t) => t && t !== "" && t !== "null" && t !== "undefined"
        );

        if (!hasValid) {
            navigate("/");
        }

    }, [navigate, ncdToken, sickleToken, PMNDP_token, nikshay_token, Uwin_token]);


    // 2. Parse beneficiary details and fetch active programs


    useEffect(() => {
        if (beneficiaryDetails) {
            try {
                const parsed = JSON.parse(beneficiaryDetails);
                setParsedBeneficiary(parsed);
                getActivePrograms();
            } catch (error) {
                console.error("Error parsing beneficiary details:", error);
            }
        }

    }, [beneficiaryDetails]);

    // 3. Once parsedBeneficiary is available, trigger all relevant data fetches

    const [sickleChecked, setSickleChecked] = useState(false);

    useEffect(() => {
        if (!parsedBeneficiary) return;

        setHasAssessmentStarted(false);
        setLoadedPrograms(prev => ({ ...prev, 1: true }));
        setLoadedPrograms(prev => ({ ...prev, 2: true }));

        parseBeneficiaryDetails();
        checkBeneficiaryAvailability();
        abhaExistInPnmdp();
        checkNikshayBeneficiaryExist();
        checkUwinBeneficiaryExist();
        checkJananiBeneficiaryExist();

        if (sickleToken && !sickleChecked) {
            sickleAbhaAvailability();
            setSickleChecked(true);
        }
    }, [parsedBeneficiary]);

    // 4. When sickleId or DiseaseType changes, update sickle ABHA data
    useEffect(() => {
        if (sickleId && DiseaseType) {
            setSickleAbhaAvailabilityData({
                sickle_id: sickleId,
                disease_type: DiseaseType,
            });
        }
    }, [sickleId, DiseaseType]);

    const handleNcdRegistrationSuccess = (individualId) => {
        const updatedBeneficiary = JSON.parse(localStorage.getItem("beneficiaryDetails"));
        setParsedBeneficiary(updatedBeneficiary);
        checkBeneficiaryAvailability();
    };

    const handleCbacSuccess = (individualId) => {
        getCbacData(individualId);
    }

    const handleNikshayRegistrationSuccess = () => {
        const updatednikshayBeneficiary = JSON.parse(localStorage.getItem("beneficiaryDetails"));
        setParsedBeneficiary(updatednikshayBeneficiary);
        checkNikshayBeneficiaryExist();
    };

    const getActivePrograms = async () => {
        try {

            setIsPageLoading(true);
            const response = await axios.get(`/nodeapi/aggregator/active-programs`);

            if (response.data.success || response.data.programs) {
                setActivePrograms(response.data.programs);
            } else {
                setActivePrograms([]);
            }

            setIsPageLoading(false);
        } catch (error) {
            setIsPageLoading(false);
            if (error.message === "Network Error") {
                toast.error(
                    "Network Error: Please check your internet connection or try again later.",
                    {
                        className: "custom-toast-error",
                    }
                );
            } else {
                toast.error("An error occurred while fetching program list.", {
                    className: "custom-toast-error",
                });
            }
        }
    };


    const searchByAbhaNcd = async (abhaNumber = "", mobile = "") => {

        const stored = localStorage.getItem("NCD_loggedinUserdetails");
        const subcenter = stored ? JSON.parse(stored) : null;

        let payload = {
            limit: 40,
            page: 0,
            name: "",
            idValue: abhaNumber,
            status: "",
            phoneNumber: mobile,
            districtScope: true,
        };

        if (subcenter.rolename != 'MO' && subcenter.rolename != 'STAFF_NURSE' && subcenter.rolename != 'DEO') {
            payload.subcenterId = subcenter?.facility || "";
            payload.villageId = null;
        }

        const records = await ncdAPI.searchBeneficiary(payload);

        const results = Array.isArray(records) ? records : [];

        return results;
    }


    const checkBeneficiaryAvailability = async () => {
        try {

            if (!ncdToken || !parsedBeneficiary) return;

            const ncdRole = localStorage.getItem("NCD_loggedinUserdetails");
            const ncdRoleData = ncdRole ? JSON.parse(ncdRole) : null;

            setLoadedPrograms(prev => ({ ...prev, 1: false }));

            if (parsedBeneficiary?.originalabha) {

                const ncdSearhdetails = JSON.parse(localStorage.getItem("NCD_Searchdetails"));

                let ncdIndividualId = null;

                if (ncdSearhdetails === null) {

                    const orignalBeneficiaryData = JSON.parse(localStorage.getItem("orignalBeneficiaryData"));

                    // 1️⃣ First call → ABHA only
                    let result = await searchByAbhaNcd(
                        parsedBeneficiary.originalabha,
                        ""
                    );

                    if (result && result.length > 0) {
                        ncdIndividualId = result[0].individualId;
                    } else {
                        result = await searchByAbhaNcd(
                            "",
                            orignalBeneficiaryData.mobile
                        );

                        if (result && result.length > 0) {
                            ncdIndividualId = result[0].individualId;
                        }
                    }

                } else {
                    ncdIndividualId = ncdSearhdetails?.searchedindividualId;
                }

                if (ncdIndividualId) {

                    setIndividualId(ncdIndividualId);
                    setprograms((prevPrograms) => ({
                        ...prevPrograms,
                        ncd: "programm",
                    }));

                    setLoadedPrograms(prev => ({ ...prev, 1: true }));

                    if (ncdRoleData.rolename == 'MO') {
                        setShowMoModal(true);
                    }

                    const screeningresult = await ncdAPI.getScreenDetails(ncdIndividualId);

                    const screeningData = screeningresult?.data || {};

                    setncdScreenDetails(screeningData);

                    setHtnScreenId(screeningData[500]?.screeningId);
                    setDiabScreenId(screeningData[600]?.screeningId);
                    setCervicalScreenId(screeningData[300]?.screeningId);
                    setOralScreeningId(screeningData[100]?.screeningId);
                    setBreastScreeningId(screeningData[200]?.screeningId);
                    setGeneralScreeningId(screeningData[900]?.screeningId);


                    const familyresp = await ncdAPI.getFamilyInfo(ncdIndividualId);
                    setFamilyInfo(familyresp.data?.familyInfo);

                    setFamIndividualInfo(familyresp.data?.individualInfo);

                    getCbacData(ncdIndividualId);

                } else {
                    setLoadedPrograms(prev => ({ ...prev, 1: true }));
                }
            } else if (parsedBeneficiary?.searchedindividualId) {

                const fetchedIndividualId = parsedBeneficiary.searchedindividualId;
                setIndividualId(fetchedIndividualId);

                setprograms((prevPrograms) => ({
                    ...prevPrograms,
                    ncd: "programm",
                }));

                setLoadedPrograms(prev => ({ ...prev, 1: true }));

                if (ncdRoleData.rolename == 'MO') {
                    setShowMoModal(true);
                }

                const screeningresult = await ncdAPI.getScreenDetails(fetchedIndividualId);

                const screeningData = screeningresult?.data || {};

                setncdScreenDetails(screeningData);

                setHtnScreenId(screeningData[500]?.screeningId);
                setDiabScreenId(screeningData[600]?.screeningId);
                setCervicalScreenId(screeningData[300]?.screeningId);
                setOralScreeningId(screeningData[100]?.screeningId);
                setBreastScreeningId(screeningData[200]?.screeningId);
                setGeneralScreeningId(screeningData[900]?.screeningId);

                const familyresp = await ncdAPI.getFamilyInfo(fetchedIndividualId);
                setFamilyInfo(familyresp.data?.familyInfo);
                setFamIndividualInfo(familyresp.data?.individualInfo);

                getCbacData(fetchedIndividualId);

            } else {
                const results = await searchNCDBeneficiaryAgain();
                if (results && results.length > 0) {
                    const ncdIndividualId = results[0]?.individualId;
                    if (ncdIndividualId) {
                        setIndividualId(ncdIndividualId);
                        setprograms((prevPrograms) => ({
                            ...prevPrograms,
                            ncd: "programm",
                        }));

                        setLoadedPrograms(prev => ({ ...prev, 1: true }));

                        if (ncdRoleData?.rolename == 'MO') {
                            setShowMoModal(true);
                        }

                        const screeningresult = await ncdAPI.getScreenDetails(ncdIndividualId);

                        const screeningData = screeningresult?.data || {};

                        setncdScreenDetails(screeningData);

                        setHtnScreenId(screeningData[500]?.screeningId);
                        setDiabScreenId(screeningData[600]?.screeningId);
                        setCervicalScreenId(screeningData[300]?.screeningId);
                        setOralScreeningId(screeningData[100]?.screeningId);
                        setBreastScreeningId(screeningData[200]?.screeningId);
                        setGeneralScreeningId(screeningData[900]?.screeningId);

                        const familyresp = await ncdAPI.getFamilyInfo(ncdIndividualId);
                        setFamilyInfo(familyresp.data?.familyInfo);

                        setFamIndividualInfo(familyresp.data?.individualInfo);

                        getCbacData(ncdIndividualId);
                    } else {
                        setLoadedPrograms(prev => ({ ...prev, 1: true }));
                    }
                } else {
                    setLoadedPrograms(prev => ({ ...prev, 1: true }));
                }
            }

        } catch (error) {
            console.error("Error in NCD healthIdMapping:", error);
        }
    };

    const searchNCDBeneficiaryAgain = async () => {
        try {
            const stored = localStorage.getItem("NCD_loggedinUserdetails");
            const subcenter = stored ? JSON.parse(stored) : null;

            let payload = {
                limit: 40,
                page: 0,
                name: parsedBeneficiary?.name || "",
                idValue: "",
                status: "",
                phoneNumber: parsedBeneficiary?.mobile || "",
                districtScope: true,
            };

            if (subcenter?.rolename != 'MO' && subcenter?.rolename != 'STAFF_NURSE' && subcenter?.rolename != 'DEO') {
                payload.subcenterId = subcenter?.facility || "";
                payload.villageId = null;
            }

            const records = await ncdAPI.searchBeneficiary(payload);

            const results = Array.isArray(records) ? records : [];
            return results;
        } catch (error) {
            console.error("Error in searchNCD:", error);
            return [];
        }
    };


    const sickleAbhaAvailability = async () => {
        try {
            if (!parsedBeneficiary) return;

            setLoadedPrograms(prev => ({ ...prev, 2: false }));
            let SickleBeneficiaryData;
            if (parsedBeneficiary.originalabha) {
                SickleBeneficiaryData = await sickleAPI.getHealthIdMapping(
                    parsedBeneficiary.originalabha
                );
            } else if (parsedBeneficiary.mobile) {
                SickleBeneficiaryData = await sickleAPI.searchBeneficiary(
                    parsedBeneficiary.mobile
                );
            } else {
                setLoadedPrograms(prev => ({ ...prev, 2: true }));
                return;
            }


            if (SickleBeneficiaryData.success === true) {
                if (parsedBeneficiary.originalabha) {
                    setprograms((prevPrograms) => ({
                        ...prevPrograms,
                        SCD: "programm",
                    }));
                }
                setLoadedPrograms(prev => ({ ...prev, 2: true }));

                if (SickleBeneficiaryData?.data?.Patientsickleid) {
                    setsickleId(SickleBeneficiaryData.data.Patientsickleid[0].sickle_id);
                }
            } else {
                setLoadedPrograms(prev => ({ ...prev, 2: true }));
            }
        } catch (error) {
            setLoadedPrograms(prev => ({ ...prev, 2: true }));
            console.error("Full Error:", error);

            // 🔥 Important: Extract backend error message
            const errorMessage =
                error?.response?.data?.message ||   // your API message
                error?.response?.data?.Message ||   // third-party API message
                error?.message ||                  // axios fallback
                "Something went wrong";

            toast.error(errorMessage);
        }
    };

    const abhaExistInPnmdp = async () => {
        try {
            if (!parsedBeneficiary || !parsedBeneficiary.originalabha) {
                setLoadedPrograms(prev => ({ ...prev, 8: true }));
                return;
            }

            setLoadedPrograms(prev => ({ ...prev, 8: false }));

            const response = await pmndpAPI.searchBeneficiary({
                abhaId: parsedBeneficiary.originalabha,
            });

            if (response?.data?.totalItems > 0) {
                setprograms((prevPrograms) => ({
                    ...prevPrograms,
                    PMNDP: "programm",
                }));
                setLoadedPrograms(prev => ({ ...prev, 8: true }));
            } else {
                setLoadedPrograms(prev => ({ ...prev, 8: true }));
            }

        } catch (error) {
            console.error("Error in PMNDP Helath NCD mapping:", error);
            setLoadedPrograms(prev => ({ ...prev, 8: true }));
        }
    };

    const getMatchedPatient = (resp, benDetails) => {

        const patientData = resp || [];

        const searchName = benDetails?.name?.trim().toLowerCase();
        const searchMobile = benDetails?.mobile?.trim();

        const matchedPatient = patientData.find((item) => {
            const fullName = `${item.FirstName || ""} ${item.LastName || ""}`
                .replace(/\s+/g, " ")
                .trim()
                .toLowerCase();

            return (
                // Name match
                (fullName.includes(searchName) ||
                    searchName.includes(fullName)) &&

                // Mobile match
                (!searchMobile ||
                    item.PrimaryPhoneNumber === searchMobile)
            );
        });

        return matchedPatient;
    };

    const checkNikshayBeneficiaryExist = async () => {
        try {

            if (!nikshay_token) return;

            const benDetails = JSON.parse(orignalBeneficiaryData);

            const mobile = benDetails.mobile;

            let gender = '';
            const g = benDetails.gender?.toUpperCase();

            if (g === 'M' || g === 'MALE') {
                gender = 'Male';
            } else if (g === 'F' || g === 'FEMALE') {
                gender = 'Female';
            } else if (g === 'O' || g === 'OTHER') {
                gender = 'Other';
            } else {
                gender = benDetails.gender || '';
            }

            if (!benDetails) return;

            setIsPageLoading(true);
            setLoadedPrograms(prev => ({ ...prev, 4: false }));

            const resp = JSON.parse(localStorage.getItem("NIKSHAY_Registration_Detials"));
            const nikshayNew = JSON.parse(localStorage.getItem("NIKSHAY_NEW_PROFILE"));

            if (benDetails.abhaNumber) {
                let searchResponse = null;
                try {
                    searchResponse = await nikshayAPI.getPatientsByHealthId({ healthId: parsedBeneficiary?.originalabha });
                    console.log("abhaSearchResponse", searchResponse);
                } catch (error) {
                    searchResponse = error.response?.data;
                    if (!error.response) {
                        toast.error(error.message || "Failed to verify Nikshay registration status due to a network issue.");
                        setNikshayPatientExists(null);
                    }
                }

                if (searchResponse) {
                    if (searchResponse?.success && searchResponse?.data?.EpisodeList?.[0]?.id) {
                        setNikshayPatientExists(true);
                        setprograms((prevPrograms) => ({
                            ...prevPrograms,
                            nikshay: "programm",
                        }));

                        try {
                            const patientDetails = await nikshayAPI.getPatients(searchResponse.data.EpisodeList[0].id);
                            console.log("abhaSearchResponse.data.id", searchResponse.data?.EpisodeList?.[0]?.id);
                            setNikshayProfileData(patientDetails);
                            setShowNikshayMainModel(false);
                        } catch (err) {
                            console.error("Error fetching Nikshay patient details:", err);
                        }
                    } else if (searchResponse?.success === false && searchResponse?.message === "No User match for the given request") {
                        setNikshayPatientExists(false);
                    } else {
                        toast.error(searchResponse?.message || "Failed to search patient by ABHA ID");
                        setNikshayPatientExists(null);
                    }
                }
            } else if (resp) {
                setNikshayPatientExists(true);
                setprograms((prevPrograms) => ({
                    ...prevPrograms,
                    nikshay: "programm",
                }));

                const patientDetails = await nikshayAPI.getPatients(resp.PatientId);
                setNikshayProfileData(patientDetails);

                setAge(patientDetails?.Age);
                const yearOfBirth = patientDetails?.DateOfBirth?.split('-')[2];
                setprofileData(prev => ({ ...prev, yearOfBirth: 'XX-XX-' + yearOfBirth }));

                const externalIds = patientDetails.ExternalIds;

                const healthId = externalIds.find(
                    item => item.Type === "HEALTH_ID"
                )?.Value;

                setprofileData(prev => ({ ...prev, originalabha: healthId }));

                setShowNikshayMainModel(false);

            } else if (nikshayNew) {
                setNikshayPatientExists(false);
            } else {

                const resp = await nikshayAPI.checkDuplicates({ PrimaryPhone: mobile, Gender: gender });

                if (Array.isArray(resp.data?.Data) && resp.data?.Data?.length > 0) {
                    setNikshayPatientExists(true);
                    setprograms((prevPrograms) => ({
                        ...prevPrograms,
                        nikshay: "programm",
                    }));

                    const matchedPatient = getMatchedPatient(resp.data?.Data, benDetails);

                    const patientDetails = await nikshayAPI.getPatients(matchedPatient.PatientId);
                    setNikshayProfileData(patientDetails);

                    setAge(patientDetails?.Age);
                    const yearOfBirth = patientDetails?.DateOfBirth?.split('-')[2];
                    setprofileData(prev => ({ ...prev, yearOfBirth: 'XX-XX-' + yearOfBirth }));

                    const externalIds = patientDetails.ExternalIds;

                    const healthId = externalIds.find(
                        item => item.Type === "HEALTH_ID"
                    )?.Value;

                    setprofileData(prev => ({ ...prev, originalabha: healthId }));

                    setShowNikshayMainModel(false);
                } else {
                    setNikshayPatientExists(false);
                }

            }
        } catch (error) {
            console.error("Error in Nikshay Helath NCD mapping:", error.message);
            setNikshayPatientExists(false);
        } finally {
            setIsPageLoading(false);
            setLoadedPrograms(prev => ({ ...prev, 4: true }));
        }
    };


    const encryptText = async (plaintext) => {
        try {
            const resEncrypt = await axios.post("nodeapi/uwin/encryption", {
                plaintext: plaintext
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return resEncrypt.data.data.encrypted;
        } catch (error) {
            console.error("Backend login error:", error);
        }
    };

    const checkUwinBeneficiaryExist = async () => {

        try {
            if (!Uwin_token) {
                setLoadedPrograms(prev => ({ ...prev, 6: false }));
                return;
            }

            if ((Uwin_token) && (!parsedBeneficiary)) {
                setLoadedPrograms(prev => ({ ...prev, 6: true }));
                return;
            }

            const userDetails = JSON.parse(localStorage.getItem('uwin_loggedinUserdetails'));

            const clientAccessToken = await axios.post(
                'nodeapi/uwin/client-token',
                {
                    user_id: userDetails ? userDetails.user_id : null,
                }
            );
            if (clientAccessToken.data.success == true) {
                localStorage.setItem("uwin_new_regitration", "0");
                const token = clientAccessToken ? clientAccessToken.data.data.accessToken : null;
                localStorage.setItem("uwin_token", token);
                let resp = null;
                if (parsedBeneficiary?.originalabha) {
                    resp = await uwinAPI.searchBeneficiary({
                        search_value: await encryptText(parsedBeneficiary.originalabha),
                        search_by: "abha-number"
                    });
                } else {
                    resp = await uwinAPI.searchBeneficiary({
                        search_value: await encryptText(parsedBeneficiary.mobile),
                        search_by: "mobile-number"
                    });
                }

                if (resp.success && resp.data.length > 0) {
                    // if (resp.data.length > 1) {
                    //     resp.data.forEach((item) => {
                    //         if (item.ben_mobile_number == parsedBeneficiary.mobile && item.ben_name == parsedBeneficiary.name) {
                    //             setBenProfileData(item);
                    //             setprograms((prevPrograms) => ({
                    //                 ...prevPrograms,
                    //                 UWIN: "programm",
                    //             }));
                    //         }
                    //     });
                    //     setLoadedPrograms(prev => ({ ...prev, 6: true }));
                    //     if (parsedBeneficiary?.originalabha) {
                    //         localStorage.setItem("uwin_new_regitration", "1");
                    //     }
                    // } else {
                    //     setBenProfileData(resp.data[0]);
                    //     setprograms((prevPrograms) => ({
                    //         ...prevPrograms,
                    //         UWIN: "programm",
                    //     }));
                    //     setLoadedPrograms(prev => ({ ...prev, 6: true }));
                    //     if (parsedBeneficiary?.originalabha) {
                    //         localStorage.setItem("uwin_new_regitration", "1");
                    //     }
                    // }
                    setLoadedPrograms(prev => ({ ...prev, 6: true }));
                    if (parsedBeneficiary?.originalabha) {
                        localStorage.setItem("uwin_new_regitration", "1");
                        setBenProfileData(resp.data[0]);
                        setprograms((prevPrograms) => ({
                            ...prevPrograms,
                            UWIN: "programm",
                        }));
                    } else {
                        resp.data.forEach((item) => {
                            if (item.ben_mobile_number == parsedBeneficiary.mobile && item.ben_name == parsedBeneficiary.name) {
                                setBenProfileData(item);
                                setprograms((prevPrograms) => ({
                                    ...prevPrograms,
                                    UWIN: "programm",
                                }));
                            }
                        });
                    }
                } else {
                    setLoadedPrograms(prev => ({ ...prev, 6: true }));
                }
            }

        } catch (error) {
            console.error("Error in UWIN Helath NCD mapping:", error);
        }
    };

    const checkJananiBeneficiaryExist = async () => {
        try {
            if (!JANANI_token) {
                setLoadedPrograms(prev => ({ ...prev, 5: true }));
                return;
            }

            if (!parsedBeneficiary?.originalabha) {
                setLoadedPrograms(prev => ({ ...prev, 5: true }));
                return;
            }

            setLoadedPrograms(prev => ({ ...prev, 5: false }));

            const response = await rchAPI.getRchBeneficiary({
                abhaNumber: parsedBeneficiary.originalabha.replace(/-/g, "")
            });

            if (response.success) {
                setJananiSearchSuccess(true);
                if (response.data.data.length > 0) {
                    setprograms((prevPrograms) => ({
                        ...prevPrograms,
                        JANANI: "programm",
                    }));
                    setRchBeneficiaryData(response.data.data[0]);
                } else {
                    setRchBeneficiaryData(null);
                }
            } else {
                setJananiSearchSuccess(false);
            }
            setLoadedPrograms(prev => ({ ...prev, 5: true }));

        } catch (error) {
            console.error("Error in JANANI beneficiary check:", error);
            setJananiSearchSuccess(false);
            setLoadedPrograms(prev => ({ ...prev, 5: true }));
        }
    };

    const parseBeneficiaryDetails = async () => {
        try {

            if (!parsedBeneficiary) return;

            setprofileData(parsedBeneficiary);

            if (parsedBeneficiary?.dob) {

                const formattedDate = formatDateAge(parsedBeneficiary.dob);
                const calculatedAge = calculateAge(formattedDate);

                setAge(calculatedAge);
            }
        } catch (error) {
            console.error("Error parsing beneficiary details:", error);
        }
    };


    const handleSaveTest = async () => {
        setShowSklRes(true);
        setSickleNextLoading(true);
        const sickleRefreshTokenData = await handleGetRefreshToken(
            localStorage.getItem("sickle_refresh_token")
        );
        if (sickleRefreshTokenData?.responseMetaData) {
            if (
                sickleRefreshTokenData.responseMetaData.responseStatusCode == 200 ||
                sickleRefreshTokenData.responseMetaData.message == "Success"
            ) {
                localStorage.setItem(
                    "sickle_token",
                    sickleRefreshTokenData.result.token
                );
                if (sickleId && DiseaseType) {
                    const patientTestDetails = await handlePatientTestDetails(
                        sickleRefreshTokenData.result.token,
                        SickleAbhaAvailabilityData
                    );
                    if (
                        patientTestDetails.Status == 200 &&
                        patientTestDetails.Message == "Success"
                    ) {
                        setPatientTestDetails(patientTestDetails.PatientDetails);
                        setSickleNextLoading(false);
                        setShowSickleForm(true); // Show the SickleForm component
                        setShowSickleModal(false);
                    } else {
                    }
                } else {
                    console.error("Sickle NCD Missing");
                }
            }
        } else {
            console.error("Invalid sickleRefreshTokenData:", sickleRefreshTokenData);
        }
    };

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);


    const getCbacData = async (individualId) => {
        try {
            const response = await ncdAPI.getCbacDetail(individualId);
            setIsCbacComplete(response?.data?.isCbacComplete === true);
        } catch (error) {
            console.error("Error fetching CBAC detail:", error);
            setIsCbacComplete(false);
            return false;
        }
    };


    const handleScreeningClick = async () => {

        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }

        if (isCbacComplete) {
            setShowNcdScreening(true);
            showSection("NCDScreening");
            setShowModal(false);
            setTimeout(() => {
                const section = document.querySelector(".accordian_section");
                if (section) {
                    section.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        } else {
            setShowCBAC(true);
            showSection("CBACKform");
            setShowModal(false);
            setTimeout(() => {
                const section = document.querySelector(".cback-section");
                if (section) {
                    section.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);

            toast.info("Please complete CBAC to start screening.", {
                className: "custom-toast-warning",
            });
        }
    };

    const openSickleModal = () => {
        setPropSickleCheckBox(true);
        setShowModals(true);
    };

    const handleNikshayActions = async (option) => {
        setShowNikshayActions(option);
        setShowNikshayMainModel(false);
        setShowNikshayAddPat(true);
        setTimeout(() => {
            const section = document.querySelector(".newRegistrationNikshay");
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100);
    };

    const handleUwinActions = async (option) => {
        if (option == 'Uwin Vaccination') {
            setShowUwinVac(true);
        }
        if (option == 'Linked Children') {
            setShowUwinLinkedChld(true);
        }
        if (option == 'Add Beneficiary') {
            setShowUwinReg(true);
            localStorage.setItem("uwin_new_regitration", "0");
        }
        setshowUwinAction(option);
    };

    const handlePmndpActions = async (option) => {
        setShowPMNDPMainModel(false);
        switch (option) {
            case "Dialysis History":
                setShowPmndpActions(option);
                setTimeout(() => {
                    const section = document.querySelector(".patientDetails");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }, 100);
                break;
            default:
                setShowPmndpActions(option);
                break;
        }
    };

    const handleSelectLabel = (option) => {
        setShowSickleActions(option);
        setShowSklDesease(true);
        setShowSklMedHis(true);
    };

    const handleCloseDiseaseManagement = () => {
        setShowSickleActions(null);
        setShowSklRes(false);
        setShowSklDesease(false);
        setShowSklMedHis(false);
    };

    const handleCloseNikshayresistation = () => {
        setShowNikshayActions(null);
        setShowNikshayAddPat(false);
        setNikshayView(false);
        setCheckedPrograms(prev => prev.filter(item => item !== 4));
    };

    const handleCloseNikshaytest = () => {
        setShowNikshayActions(null);
        setShowNikshayAddPat(false);
        setNikshayView(false);
        setCheckedPrograms(prev => prev.filter(item => item !== 4));
    };

    const handleCloseNikshayview = () => {
        setShowNikshayActions(null);
        setNikshayView(false);
        setShowNikshayAddPat(false);
        setCheckedPrograms(prev => prev.filter(item => item !== 4));
    };

    const handleCloseSickleMedication = () => {
        setShowSickleActions(null);
        setShowSklRes(false);
        setShowSklDesease(false);
        setShowSklMedHis(false);
    };

    const handleClosepmndpregistration = () => {
        setShowPmndpActions(null);
        setShowPMNDP(false);
    };

    const handleCloseLinkedChildren = () => {
        setshowUwinAction(null);
        setShowUwinLinkedChld(false);
        setShowUwinVac(false);
    };

    const handleCloseVacinationUWIN = () => {
        setshowUwinAction(null);
        setShowUwinVac(false);
        setShowUwinLinkedChld(false);
    };

    const handleClosedialysishistory = () => {
        setShowPmndpActions(null);
        setShowDialysisHistory(false);
    };

    const handleCloseSickleregistration = () => {
        setShowSickleReg(null)
        setShowSklRegistration(false);
    };

    const handleCloseRchRegistration = () => {
        setShowRchReg(false);
        setShowRchPreview(false);
        setCheckedPrograms(prev => prev.filter(item => item !== 5));
    };

    const openNikshayModel = () => {
        setPropSickleCheckBox(true);
        setShowNikshayMainModel(true);
    };

    const handleCloseSickleForm = () => {
        setShowSickleForm(null);
        setShowSklRes(false);
        setShowSklDesease(false);
        setShowSklMedHis(false);
    };

    const openSickleBenficiaryReg = () => {
        setPropSickleCheckBox(true);
        setShowSickleReg(true);
        setShowSklRegistration(true);
    };

    useEffect(() => {
        targetRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [ShowSickleReg]);

    const handleFollowupClick = () => {

        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }

        setShowNcdFollowup(true);

        showSection("Followptreatment");
        closeModal(false);

        setTimeout(() => {
            const section = document.querySelector(".followup-treatment-section");
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100);
    };


    const handelCbacClick = () => {

        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }

        setShowCBAC(true);

        showSection("CBACKform");

        closeModal(false);

        setTimeout(() => {
            const section = document.querySelector(".cback-section");
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100); // delay ensures DOM has updated; you can increase to 200 if needed
    };

    const handleMemberClick = () => {

        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }

        setShowAddMember(true);

        closeModal(false);

        setTimeout(() => {
            const section = document.querySelector(".add-member-section");
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100);
    };

    const handleAssessmentTabChange = (event, newValue) => {
        setHasAssessmentStarted(true);
        setActiveAssessmentTab(newValue);

        setShowInitialAssessment(newValue === 'initialassessment');
        setShowHypertensionFollowup(newValue === 'Hypertension');
        setShowDiabetesFollowup(newValue === 'Diabetes');
        setShowOralCancer(newValue === 'OralCancer');
        setShowBreastCancer(newValue === 'BreastCancer');
        setShowCervicalCancer(newValue === 'CervicalCancer');
        setShowInvestigation(newValue === 'Investigation');
        setShowGeneral(newValue === 'General');

        let conditionId = null;
        let showPlus = false;

        if (newValue === 'Hypertension') {
            conditionId = 500;
            showPlus = showHtnPlus;
        } else if (newValue === 'Diabetes') {
            conditionId = 600;
            showPlus = showDiabetesPlus;
        } else if (newValue === 'OralCancer') {
            conditionId = 100;
            showPlus = showOralPlus;
        } else if (newValue === 'BreastCancer') {
            conditionId = 200;
            showPlus = showBreastPlus;
        } else if (newValue === 'CervicalCancer') {
            conditionId = 300;
            showPlus = showCervicalPlus;
        } else if (newValue === 'General') {
            conditionId = 900;
            showPlus = showGeneralPlus;
        }

        if (conditionId && showPlus && individualId) {
            ncdAPI.addExamination(conditionId, individualId, {})
                .then(response => {

                    const screeningId = response?.data?.screeningId;

                    if (newValue === 'Hypertension') {
                        setHtnScreenId(screeningId);
                        setShowHtnPlus(false);
                    } else if (newValue === 'Diabetes') {
                        setDiabScreenId(screeningId);
                        setShowDiabetesPlus(false);
                    } else if (newValue === 'OralCancer') {
                        setOralScreeningId(screeningId);
                        setShowOralPlus(false);
                    } else if (newValue === 'BreastCancer') {
                        setBreastScreeningId(screeningId);
                        setShowBreastPlus(false);
                    } else if (newValue === 'CervicalCancer') {
                        setCervicalScreenId(screeningId);
                        setShowCervicalPlus(false);
                    } else if (newValue === 'General') {
                        setGeneralScreeningId(screeningId);
                        setShowGeneralPlus(false);
                    }
                })
                .catch(err => {
                    console.error(`Failed to add examination for condition ${conditionId}:`, err);
                });
        }

        const sectionClasses = {
            initialassessment: '.initial-assessment-section',
            Hypertension: '.hypertension-followup-section',
            Diabetes: '.diabetes-followup-section',
            OralCancer: '.oral-cancer-section',
            BreastCancer: '.breast-cancer-section',
            CervicalCancer: '.cervical-cancer-section',
            Investigation: '.investigation-section',
            General: '.general-section'
        };

        const selector = sectionClasses[newValue];
        if (selector) {
            setTimeout(() => {
                const section = document.querySelector(selector);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        }
    };

    const handleInitialAssessmentClick = () => {
        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }
        setShowMoModal(false);
        handleAssessmentTabChange(null, 'initialassessment');
    };

    const handleHypertensionFollowupClick = () => {
        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }
        setShowMoModal(false);
        handleAssessmentTabChange(null, 'Hypertension');
    };

    const handleDiabetesFollowupClick = (tabKey = 'Diabetes') => {
        if (!checkedPrograms.includes(1)) {
            setCheckedPrograms(prev => [...prev, 1]);
        }
        setShowMoModal(false);
        handleAssessmentTabChange(null, tabKey);
    };

    const [checkedPrograms, setCheckedPrograms] = useState([]);
    const [showNcdReg, setShowNcdReg] = useState(false);
    const [showCBAC, setShowCBAC] = useState(false);
    const [showNcdScreening, setShowNcdScreening] = useState(false);
    const [showNcdFollowup, setShowNcdFollowup] = useState(false);
    const [showAddMember, setShowAddMember] = useState(false);
    const [showInitialAssessment, setShowInitialAssessment] = useState(false);
    const [showHypertensionFollowup, setShowHypertensionFollowup] = useState(false);
    const [showDiabetesFollowup, setShowDiabetesFollowup] = useState(false);
    const [showOralCancer, setShowOralCancer] = useState(false);
    const [showBreastCancer, setShowBreastCancer] = useState(false);
    const [showCervicalCancer, setShowCervicalCancer] = useState(false);
    const [showInvestigation, setShowInvestigation] = useState(false);
    const [showGeneral, setShowGeneral] = useState(false);
    const isAnyNCDComponentOpen = () => showNcdReg || showCBAC || showNcdScreening || showNcdFollowup || showAddMember || showInitialAssessment || showHypertensionFollowup || showDiabetesFollowup || showOralCancer || showBreastCancer || showCervicalCancer || showInvestigation || showGeneral;

    ///////////////////////////////////////////////////////////////////////////////

    const [showSklRes, setShowSklRes] = useState(false);
    const [showSklDesease, setShowSklDesease] = useState(false);
    const [showSklMedHis, setShowSklMedHis] = useState(false);
    const [showSklRegistration, setShowSklRegistration] = useState(false);
    const isAnySickleComponentOpen = () => showSklRes || showSklDesease || showSklMedHis || showSklRegistration;

    ///////////////////////////////////////////////////////////////////////////////

    const [showDialysisHistory, setShowDialysisHistory] = useState(false);
    const [showPMNDP, setShowPMNDP] = useState(false);

    const isAnyPMNDPComponentOpen = () => showDialysisHistory || showPMNDP;

    /////////////////////////////////////////////////////////////////////////////////

    const [showUwinLinkedChld, setShowUwinLinkedChld] = useState(false);
    const [showUwinVac, setShowUwinVac] = useState(false);

    const isAnyUWINComponentOpen = () => showUwinLinkedChld || showUwinVac;

    /////////////////////////////////////////////////////////////////////////////////

    const [showNikshayAddPat, setShowNikshayAddPat] = useState(false);

    const isAnyNikshayComponentOpen = () => showNikshayAddPat || nikshayView;

    useEffect(() => {
        if (!isAnyNCDComponentOpen()) {
            setCheckedPrograms((prev) => prev.filter((id) => id !== 1));
        }

        if (!isAnySickleComponentOpen()) {
            setCheckedPrograms((prev) => prev.filter((id) => id !== 2));
        }

        if (!isAnyPMNDPComponentOpen()) {
            setCheckedPrograms((prev) => prev.filter((id) => id !== 8));
        }

        if (!isAnyUWINComponentOpen()) {
            setCheckedPrograms((prev) => prev.filter((id) => id !== 6));
        }

        if (!isAnyNikshayComponentOpen()) {
            setCheckedPrograms((prev) => prev.filter((id) => id !== 4));
        }

        if (!showRchReg && !showRchPreview) {
            setCheckedPrograms((prev) => prev.filter((id) => id !== 5));
        }

    }, [showNcdReg, showCBAC, showNcdScreening, showNcdFollowup, showDialysisHistory, showPMNDP, showUwinLinkedChld, showUwinVac, showNikshayAddPat, nikshayView, showSklRes, showSklDesease, showSklMedHis, showSklRegistration, showInitialAssessment, showHypertensionFollowup, showDiabetesFollowup, showRchReg, showOralCancer, showBreastCancer, showCervicalCancer, showInvestigation, showGeneral]);

    const handleCheckboxClick = (prog) => {
        // Check if user is logged into the program

        if (!checkUserLoginForProgram(prog.program_id)) {
            setShowLoginModal(true);
            return;
        }

        if (prog.program_id === 1) {

            individualId ? openModal() : showSection("FamilyForm");

            if (!individualId) {
                if (!checkedPrograms.includes(1)) {
                    setCheckedPrograms(prev => [...prev, 1]);
                }
                setShowNcdReg(true);
            }

        }

        if (prog.program_id === 2) {

            if (programs.SCD) {
                toast.info("Coming Soon", {
                    className: "custom-toast-info",
                });
                // openSickleModal();
            } else {
                openSickleBenficiaryReg();
                setShowSklRegistration(true);
                // toast.info("Registration coming soon", {
                //     className: "custom-toast-info",
                // });
            }

            if (!checkedPrograms.includes(2)) {
                setCheckedPrograms(prev => [...prev, 2]);
            }

            // if (localStorage.getItem("sickle_refresh_token")) {
            // } else {
            //     openSickleModal();
            //     toast.info("Registration coming soon", {
            //         className: "custom-toast-info",
            //     });
            // }
        }


        if (prog.program_id === 4) {
            if (localStorage.getItem("NIKSHAY_valid_user")) {
                if (nikshayPatientExists === true) {
                    // Patient exists - show modal with options
                    // setShowNikshayMainModel(true);

                    setShowNikshayActions('View Nikshay Details');

                } else if (nikshayPatientExists === false) {
                    // No patient found - go directly to registration
                    setShowNikshayActions('New Registration Nikshay');
                    setShowNikshayAddPat(true);
                    setTimeout(() => {
                        const section = document.querySelector(".newRegistrationNikshay");
                        if (section) {
                            section.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                    }, 100);
                } else {
                    //  setShowNikshayMainModel(true);
                    setShowNikshayActions('View Nikshay Details');
                }
            } else {
                // Not logged in - show modal for login
                // setShowNikshayMainModel(true);
                setShowNikshayActions('View Nikshay Details');
            }

            if (!checkedPrograms.includes(4)) {
                setCheckedPrograms(prev => [...prev, 4]);
            }
        }

        if (prog.program_id === 8) {
            if (!checkedPrograms.includes(8)) {
                setCheckedPrograms(prev => [...prev, 8]);
            }

            if (localStorage.getItem("PMNDP_token")) {
                if (programs?.PMNDP) {
                    setShowDialysisHistory(true);
                    handlePmndpActions("Dialysis History");
                } else {
                    handlePmndpActions("Add New Patient");
                    setShowPMNDP(true);
                }
            } else {
                if (programs?.PMNDP) {
                    setShowDialysisHistory(true);
                    handlePmndpActions("Dialysis History");
                } else {
                    toast.info("No dialysis history found for this beneficiary.", {
                        className: "custom-toast-info",
                    });
                }
            }
        }

        if (prog.program_id === 6) {

            programs.UWIN ? setShowUwinMainModal(true) : setShowUwinReg(true);
            if (!checkedPrograms.includes(6)) {
                setCheckedPrograms(prev => [...prev, 6]);
            }

        }

        if (prog.program_id === 5) {
            if (programs.JANANI === "programm") {
                setShowRchPreview(true);
            } else {
                setShowRchReg(true);
            }
            if (!checkedPrograms.includes(5)) {
                setCheckedPrograms(prev => [...prev, 5]);
            }
        }
    };

    useEffect(() => {
        if (programs?.ncd === 'programm') {
            fetchPersonalExamination();
        }
    }, [programs.ncd]);

    // Fetch UWIN data when program becomes active
    // useEffect(() => {
    //     if (programs?.UWIN === 'programm' && benProfileData) {
    //         fetchUwinVitals();
    //     }
    // }, [programs.UWIN, benProfileData]);

    // console.log("Current Context State (fieldValues):", fieldValues);

    const fetchPersonalExamination = async () => {
        try {
            if (!individualId) return;

            setLoading(true);

            const response = await ncdAPI.getPersonalExamination(individualId);

            if (response?.data) {
                // Store in Context - NCD uses default field names
                updateFieldValues(response?.data, programs);
            }
        } catch (error) {
            setError("Error fetching personal examination data");

        } finally {
            setLoading(false);
        }
    };



    // const fetchUwinVitals = async () => {
    //     try {

    //     } catch (error) {
    //         console.error("Error fetching UWIN vitals:", error);
    //     }
    // };

    // console.log("programs----->", programs)

    // Example: Get form data with just the values (for input fields)
    const formData = useMemo(() => {
        // This will now re-run automatically whenever fieldValues changes
        return autoPopulateForm(fieldValues, ['weight', 'height', 'bmi']);
    }, [fieldValues]);

    // Example: Get latest weight with full details (value, program, date)
    const latestWeight = useMemo(() => {
        return getLatestFieldValue(fieldValues, 'weight');
    }, [fieldValues]);

    // Example: Get latest height with full details
    const latestHeight = useMemo(() => {
        return getLatestFieldValue(fieldValues, 'height');
    }, [fieldValues]);

    // Example: Get latest BMI with full details
    const latestBmi = useMemo(() => {
        return getLatestFieldValue(fieldValues, 'bmi');
    }, [fieldValues]);

    // console.log("formData", formData)
    // console.log("latestWeight (with details):", latestWeight);
    // console.log("latestHeight (with details):", latestHeight);
    // console.log("latestBmi (with details):", latestBmi);

    return (
        <>
            {isPageLoading && <Loader />}

            <div className="page-detailsABHA">

                <div className="container-fluid">
                    <section className="beneficiaryDetails">
                        <div className="row">
                            <div className="col-xs-12 col-md-5">
                                <div className="beneficiaryDetailsBox">
                                    <h4 className="title">Beneficiary Details</h4>
                                    <div className="beneficiaryDetailsRow">
                                        <div className="beneficiaryDetailsUserPhoto">
                                            {profileData?.base64photo ? (
                                                <img
                                                    src={`data:image/jpeg;base64,${profileData.base64photo}`}
                                                    alt="Profile"
                                                    className="primage"
                                                />
                                            ) : (
                                                <img
                                                    src={profileData?.kycphoto}
                                                    alt="Beneficiary"
                                                    className="beneficiary-image"
                                                />
                                            )}
                                        </div>

                                        <div className="beneficiaryDetailsUserDetails">
                                            <h5>
                                                {profileData?.name}{" "}
                                                <span
                                                    style={{
                                                        background:
                                                            profileData?.gender?.trim().toLowerCase() ===
                                                                "female"
                                                                ? "#F9DAF0"
                                                                : "#e0f2ff",
                                                    }}
                                                >
                                                    {profileData?.gender}
                                                </span>
                                            </h5>
                                            <ul>
                                                <li>
                                                    <img src="/images/name.png" />
                                                    {profileData?.yearOfBirth
                                                        ? profileData.yearOfBirth
                                                        : "N/A"}{" "}
                                                    {age ? <span>({age} Yrs)</span> : null}
                                                </li>
                                                <li>
                                                    <img src="/images/mobile-phone.png" />
                                                    {profileData?.mobile
                                                        ? profileData.mobile
                                                        : "XXXXXXXXXX"}{" "}
                                                </li>
                                                <li>
                                                    <img src="/images/id-number.png" />
                                                    {profileData?.originalabha ? (
                                                        profileData.originalabha
                                                    ) : (
                                                        <span>ABHA not linked</span>
                                                    )}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-7">
                                <Timeline individualId={individualId} parsedBeneficiary={parsedBeneficiary} nikshayData={nikshayProfileData} />
                            </div>
                        </div>
                    </section>

                    <section className="program-selection-sectionn selectProgram">
                        <h4 className="program-selection-title">Select Program</h4>
                        <div className="programs">
                            {(localStorage.getItem("PMNDP_token")
                                ? activePrograms?.filter((prog) => prog.program_id === 8)
                                : activePrograms
                            )?.map((prog, index) => {
                                let isDisabled = !loadedPrograms[prog.program_id]; // disable if not loaded yet
                                if (prog.program_id === 5 && !jananiSearchSuccess) {
                                    isDisabled = true;
                                }

                                if (!checkUserLoginForProgram(prog.program_id)) {
                                    return null;
                                }

                                return (
                                    <div className="selectProgramCol" key={index} style={{ pointerEvents: isDisabled ? 'none' : 'auto', opacity: isDisabled ? 0.5 : 1 }}>
                                        <div
                                            className={`program 
                                                ${prog.program_id === 1
                                                    ? programs.ncd
                                                    : ""
                                                } 
                                                ${prog.program_id === 2
                                                    ? programs.SCD
                                                    : ""
                                                } 
                                                ${prog.program_id === 4
                                                    ? programs.nikshay
                                                    : ""
                                                } 
                                                ${prog.program_id === 5
                                                    ? programs.JANANI
                                                    : ""
                                                }
                                                ${prog.program_id === 6
                                                    ? programs.UWIN
                                                    : ""
                                                }
                                                ${prog.program_id === 8
                                                    ? programs.PMNDP
                                                    : ""
                                                }`}
                                        >
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="program-checkbox"
                                                    id={`checkbox-${prog.program_id}`}
                                                    value={prog.program_id}
                                                    className="custom-checkbox-ncd"
                                                    onChange={() => handleCheckboxClick(prog)}
                                                    checked={checkedPrograms.includes(prog.program_id)}
                                                />
                                                <img
                                                    src={
                                                        prog.program_id === 1
                                                            ? "/images/programs_logo/ncd.svg"
                                                            : prog.program_id === 2
                                                                ? "/images/programs_logo/sickle.svg"?.default || "/images/programs_logo/sickle.svg"
                                                                : prog.program_id === 4
                                                                    ? "/images/programs_logo/nikshay.svg"?.default || "/images/programs_logo/nikshay.svg"
                                                                    : prog.program_id === 5
                                                                        ? "/images/programs_logo/janani.png"?.default || "/images/programs_logo/janani.png"
                                                                        : prog.program_id === 6
                                                                            ? "/images/programs_logo/uwin.svg"?.default || "/images/programs_logo/uwin.svg"
                                                                            : prog.program_id === 8
                                                                                ? "/images/programs_logo/pmndp.svg"?.default || "/images/programs_logo/pmndp.svg"
                                                                                : ""
                                                    }
                                                    alt="program-icon"
                                                    className="program-icon"
                                                />

                                                <span>{prog.program_name}</span>
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="programNoticeId">
                            <div className="identitleCol">
                                <span className="colorIdentiy color1"></span>
                                <h4>Indicates beneficiary already in the program</h4>
                            </div>
                            <div className="identitleCol">
                                <span className="colorIdentiy color2"></span>
                                <h4>Indicates beneficiary not in program</h4>
                            </div>
                            <div className="identitleCol">
                                <span className="colorIdentiy color3"></span>
                                <h4>Select to add/view past records</h4>
                            </div>
                        </div>
                    </section>

                    {!isHidden("NCDScreening") && (
                        <NcdForm
                            hideSection={hideSection}
                            individualId={individualId}
                            profileData={profileData}
                            familyInfo={familyInfo}
                            setShowNcdScreening={setShowNcdScreening}
                        />
                    )}

                    {!isHidden("Followptreatment") && (() => {
                        if (!hasAccess) return false;
                        return permissions.length === 0 || hasPermission(permissions, "Followup dt");
                    })() && (
                            <section className="/images/follow-up.svg">
                                <FollowupTreatment
                                    hideSection={hideSection}
                                    individualId={individualId}
                                    htnScreenId={htnScreenId}
                                    diabScreenId={diabScreenId}
                                    setShowNcdFollowup={setShowNcdFollowup}
                                />
                            </section>
                        )}

                    {showPMNDPMainModel && (
                        <PMNDPMaineModel
                            onClosePMNDPMainModel={() => setShowPMNDPMainModel(false)}
                            onSelect={handlePmndpActions}
                            openSlot={() => {
                                {
                                    setSlotModel(true);
                                    setShowPMNDPMainModel(false);
                                }
                            }}
                        />
                    )}

                    {slotModel && <AddPatentsModel onClose={() => setSlotModel(false)} />}

                    {showNikshayMainModel && (
                        <Nikshaymainmodal
                            onCloseNikshayMainModel={() => {
                                setShowNikshayMainModel(false)
                                setShowNikshayActions(null)
                                setCheckedPrograms((prev) => prev.filter((id) => id !== 4));
                            }
                            }
                            onSelect={handleNikshayActions} data={nikshayProfileData}
                        />
                    )}

                    {nikshayView && (
                        <RegistrationView onClose={handleCloseNikshayview} data={nikshayProfileData} />
                    )}

                    {!isHidden("FamilyForm") && (() => {
                        if (!hasAccess) return false;
                        return permissions.length === 0 || hasPermission(permissions, "family");

                    })() && !showAddMember && (
                            <Faimily
                                hideSection={hideSection}
                                profileData={profileData}
                                setshowCBACform={setshowCBACform}
                                setIndividualId={setIndividualId}
                                setFamilyInfo={setFamilyInfo}
                                setShowNcdReg={setShowNcdReg}
                                onRegistrationSuccess={handleNcdRegistrationSuccess}
                            />
                        )}

                    {showAddMember && (
                        <div className="add-member-section">
                            <Addmember
                                hideSection={() => setShowAddMember(false)}
                                profileData={profileData}
                                setshowCBACform={setshowCBACform}
                                familyInfo={familyInfo}
                                setShowNcdReg={setShowNcdReg}
                            />
                        </div>
                    )}

                    {programs.ncd === "programm" && isMoOrStaffNurse && (
                        <Box
                            className="ncd-assessment-tabs-wrapper"
                            sx={{
                                width: '100%',
                                bgcolor: '#fff',
                                mb: 3,
                                mt: 3,
                                borderRadius: '12px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                                p: 0.8,
                                border: '1px solid #eef2f5'
                            }}
                        >
                            <Box sx={{ mb: 1, px: 1 }}>
                                <span style={{ fontSize: '13px', fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Patient Assessment Menu
                                </span>
                            </Box>
                            <Tabs
                                value={activeAssessmentTab}
                                onChange={handleAssessmentTabChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{
                                    minHeight: 'auto',
                                    '& .MuiTabs-flexContainer': {
                                        gap: '10px',
                                        padding: '10px',
                                    },
                                    '& .MuiTabs-indicator': {
                                        display: 'none',
                                    },
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        minHeight: '38px',
                                        py: 1,
                                        px: 2.5,
                                        color: '#495057',
                                        borderRadius: '8px',
                                        border: '1px solid #dee2e6',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            color: '#007fff',
                                            borderColor: '#007fff',
                                            backgroundColor: 'rgba(0, 127, 255, 0.04)',
                                        },
                                        '&.Mui-selected': {
                                            color: '#fff',
                                            backgroundColor: '#1976d2',
                                            borderColor: '#1976d2',
                                            boxShadow: '0px 4px 10px rgba(25, 118, 210, 0.25)',
                                        },
                                    },
                                }}
                            >
                                <Tab label="Initial Assessment" value="initialassessment" onClick={() => handleAssessmentTabChange(null, "initialassessment")} />
                                <Tab label={`${showHtnPlus ? '+ ' : ''}Hypertension`} value="Hypertension" onClick={() => handleAssessmentTabChange(null, "Hypertension")} />
                                <Tab label={`${showDiabetesPlus ? '+ ' : ''}Diabetes`} value="Diabetes" onClick={() => handleAssessmentTabChange(null, "Diabetes")} />
                                <Tab label={`${showOralPlus ? '+ ' : ''}Oral Cancer`} value="OralCancer" onClick={() => handleAssessmentTabChange(null, "OralCancer")} />
                                {profileData?.gender?.trim().toLowerCase() === "female" && (
                                    <Tab label={`${showBreastPlus ? '+ ' : ''}Breast Cancer`} value="BreastCancer" onClick={() => handleAssessmentTabChange(null, "BreastCancer")} />
                                )}
                                {profileData?.gender?.trim().toLowerCase() === "female" && (
                                    <Tab label={`${showCervicalPlus ? '+ ' : ''}Cervical Cancer`} value="CervicalCancer" onClick={() => handleAssessmentTabChange(null, "CervicalCancer")} />
                                )}
                                <Tab label="Investigation" value="Investigation" onClick={() => handleAssessmentTabChange(null, "Investigation")} />
                                <Tab label={`${showGeneralPlus ? '+ ' : ''}General`} value="General" onClick={() => handleAssessmentTabChange(null, "General")} />
                            </Tabs>
                        </Box>
                    )}

                    {showInitialAssessment && (
                        <div className="initial-assessment-section">
                            <InitialAssessmentForm
                                onSubmit={(values) => {
                                    toast.success('Initial Assessment saved successfully!', {
                                        className: 'custom-toast-success',
                                    });
                                    setShowInitialAssessment(false);
                                }}
                                onSkip={() => {
                                    setShowInitialAssessment(false);
                                }}
                                setShowInitialAssessment={setShowInitialAssessment}
                                individualId={individualId}
                                gender={profileData?.gender}
                            />
                        </div>
                    )}

                    {showHypertensionFollowup && (
                        <div className="hypertension-followup-section">
                            <HypertensionFollowup
                                individualId={individualId}
                                htnScreenId={htnScreenId}
                                setShowHypertensionFollowup={setShowHypertensionFollowup}
                                onSubmit={(values) => {
                                    toast.success('Hypertension treatment saved successfully!', {
                                        className: 'custom-toast-success',
                                    });
                                    setShowHypertensionFollowup(false);
                                }}
                            />
                        </div>
                    )}

                    {showDiabetesFollowup && (
                        <div className="diabetes-followup-section">
                            <DiabetesFollowup
                                individualId={individualId}
                                dbScreenId={diabScreenId}
                                setShowDiabetesFollowup={setShowDiabetesFollowup}
                                onSubmit={(values) => {
                                    toast.success('Diabetes treatment saved successfully!', {
                                        className: 'custom-toast-success',
                                    });
                                    setShowDiabetesFollowup(false);
                                }}
                            />
                        </div>
                    )}

                    {showOralCancer && (
                        <div className="oral-cancer-section" style={{ position: 'relative', background: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                            <h3 className="followup-container-title" style={{ fontSize: '18px', fontWeight: 600, color: '#202124', marginBottom: '15px' }}>
                                Oral Cancer Screening
                            </h3>
                            <OralScreening
                                individualId={individualId}
                                oralScreeningId={oralScreeningId}
                                viewMode="ADD"
                            />
                            <Button
                                onClick={() => setShowOralCancer(false)}
                                sx={{
                                    border: "2px solid #A9A9A9",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "100%",
                                    cursor: "pointer",
                                    position: "absolute",
                                    right: "-8px",
                                    top: "-10px",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "auto",
                                    p: 0,
                                    "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.05)",
                                    },
                                }}
                            >
                                <img src={"/images/closing.svg"} alt="Close" style={{ width: "16px" }} />
                            </Button>
                        </div>
                    )}

                    {showBreastCancer && (
                        <div className="breast-cancer-section" style={{ position: 'relative', background: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                            <h3 className="followup-container-title" style={{ fontSize: '18px', fontWeight: 600, color: '#202124', marginBottom: '15px' }}>
                                Breast Cancer Screening
                            </h3>
                            <BreastScreening
                                individualId={individualId}
                                breastScreeningId={breastScreeningId}
                                viewMode="ADD"
                            />
                            <Button
                                onClick={() => setShowBreastCancer(false)}
                                sx={{
                                    border: "2px solid #A9A9A9",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "100%",
                                    cursor: "pointer",
                                    position: "absolute",
                                    right: "-8px",
                                    top: "-10px",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "auto",
                                    p: 0,
                                    "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.05)",
                                    },
                                }}
                            >
                                <img src={"/images/closing.svg"} alt="Close" style={{ width: "16px" }} />
                            </Button>
                        </div>
                    )}

                    {showCervicalCancer && (
                        <div className="cervical-cancer-section" style={{ position: 'relative', background: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                            <h3 className="followup-container-title" style={{ fontSize: '18px', fontWeight: 600, color: '#202124', marginBottom: '15px' }}>
                                Cervical Cancer Screening
                            </h3>
                            <CervicalScreening
                                individualId={individualId}
                                cervicalScreeningId={cervicalScreeningId}
                                viewMode="ADD"
                            />
                            <Button
                                onClick={() => setShowCervicalCancer(false)}
                                sx={{
                                    border: "2px solid #A9A9A9",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "100%",
                                    cursor: "pointer",
                                    position: "absolute",
                                    right: "-8px",
                                    top: "-10px",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "auto",
                                    p: 0,
                                    "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.05)",
                                    },
                                }}
                            >
                                <img src={"/images/closing.svg"} alt="Close" style={{ width: "16px" }} />
                            </Button>
                        </div>
                    )}

                    {showInvestigation && (
                        <div className="investigation-section">
                            <Investigation
                                individualId={individualId}
                                setShowInvestigation={setShowInvestigation}
                            />
                        </div>
                    )}

                    {showGeneral && (
                        <div className="general-section">
                            <General
                                individualId={individualId}
                                setShowGeneral={setShowGeneral}
                                generalScreeningId={generalScreeningId}
                            />
                        </div>
                    )}

                    {showNikshayActions === VIEWCONSTANT.NewRegistrationNikshay && !nikshayPatientExists && (
                        <NewRegistrationNikshay onClose={handleCloseNikshayresistation} onRegistrationSuccess={handleNikshayRegistrationSuccess} />
                    )}

                    {showNikshayActions === VIEWCONSTANT.ViewNikshayDetails && (
                        <RegistrationView
                            onClose={handleCloseNikshaytest}
                            data={nikshayProfileData}
                            setShowNikshayActions={setShowNikshayActions}
                            initialTab={nikshayInitialTab}
                        />
                    )}

                    {showNikshayActions === VIEWCONSTANT.AddTestNikshay && (
                        <NikshayTest
                            onClose={handleCloseNikshaytest}
                            setShowNikshayActions={setShowNikshayActions}
                            setNikshayInitialTab={setNikshayInitialTab}
                            patientId={nikshayProfileData?.Id}
                            nikshayProfileData={nikshayProfileData}
                            onTestAdded={() => {
                                setNikshayInitialTab("test");
                                setShowNikshayActions(VIEWCONSTANT.ViewNikshayDetails);
                            }}
                        />
                    )}

                    {showPmndpActions === VIEWCONSTANT.AddNewPateint && (
                        <PMNDPRegistrationForm onClose={handleClosepmndpregistration} />
                    )}

                    {showPmndpActions === VIEWCONSTANT.DialysisHistory && (
                        <DialysisHistory
                            abhaNumber={parsedBeneficiary?.originalabha}
                            onClose={handleClosedialysishistory}
                        />
                    )}

                    {ShowSickleActions === VIEWCONSTANT.medicalHistory && (
                        <SickleMedication
                            sickleId={sickleId}
                            onClose={handleCloseSickleMedication}
                        />
                    )}
                    {ShowSickleActions === VIEWCONSTANT.DiseaseManagement && (
                        <DiseaseManagement
                            sickleId={sickleId}
                            onClose={handleCloseDiseaseManagement}
                            patientTestDetails={patientTestDetails}
                        />
                    )}

                    {showUwinAction === VIEWCONSTANT.Vaccinationuwin && (
                        <Vaccinationuwin
                            onClose={handleCloseVacinationUWIN}
                            benProfileData={benProfileData}
                            handleCloseLinkedChildren={handleCloseLinkedChildren}
                        />
                    )}
                    {showUwinAction === VIEWCONSTANT.Linkedchildren && (
                        <Linkedchildren
                            onClose={handleCloseLinkedChildren}
                            benProfileData={benProfileData}
                        />
                    )}

                    {ShowSickleReg && (
                        <>
                            <section className="accordian_section">
                                <SickleRegistration targetRef={targetRef}
                                    onClose={handleCloseSickleregistration} />
                            </section>
                        </>
                    )}

                    {/* Dynamically Rendered SickleForm */}
                    {showSickleForm && (
                        <section className="sickle-form-section">
                            <Sickleform
                                onClose={handleCloseSickleForm}
                                onSaveTest={handleSaveTest}
                                patientTestDetails={patientTestDetails}
                                sickleId={sickleId}
                                TestType={testType}
                                DiseaseType={DiseaseType}
                            />
                        </section>
                    )}

                    {!isHidden("CBACKform") && (() => {
                        if (!hasAccess) return false;
                        return permissions.length === 0 || hasPermission(permissions, "cbac");
                    })() && (
                            <section className="followup-treatment-section cback-section">
                                <CBACform hideSection={hideSection} showSection={showSection} individualId={individualId} setShowCBAC={setShowCBAC} setShowNcdScreening={setShowNcdScreening} profileData={profileData} famIndividualInfo={famIndividualInfo} onCBACSuccess={handleCbacSuccess} />
                            </section>
                        )}

                    {showUwinReg && <UwinPage />}

                    {showRchReg && <RCHRegistration onClose={handleCloseRchRegistration} checkJananiBeneficiaryExist={checkJananiBeneficiaryExist} />}

                    {showRchPreview && <RCHRegistrationPreview onClose={handleCloseRchRegistration} rchBeneficiaryData={rchBeneficiaryData} />}

                    {showUwinMainModal && (
                        <Uwinmainmodal
                            onCloseUwinMainModal={() => setShowUwinMainModal(false)}
                            onSelect={handleUwinActions}
                        />
                    )}
                </div>
                {/* --------------------------- Sickle Model Start------------------------------ */}

                {showSickleModal && (
                    <Sickle
                        onClose={() => setShowSickleModal(false)}
                        onSaveTest={handleSaveTest}
                        SickleNextLoading={SickleNextLoading}
                        setDiseaseType={setDiseaseType}
                        setTestType={setTestType}
                    />
                )}

                {showModals && (
                    <SickleMainModel
                        onSelect={handleSelectLabel}
                        onClose={() => setShowModals(false)}
                        openSickleForm={() => {
                            setShowModals(false);
                            setShowSickleModal(true);
                        }}
                    />
                )}

                {/* /* ---------------------------- Sickle Model End ------------------------------ */}

                {showModal && (
                    <>
                        <div
                            className="modal fade show d-block verificationModel"
                            id="exampleModal"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                            style={{ background: "rgba(0,0,0,0.5)" }}
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header border-bottom-0 ">
                                        <div className="text-center headerText">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                NCD Program
                                            </h5>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => setShowModal(false)}
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            {localStorage.getItem("NCD_token") ? (
                                                <>
                                                    {(() => {
                                                        const availableOptions = [];

                                                        if (hasPermission(permissions, 'cbac')) {
                                                            availableOptions.push({
                                                                key: 'cbac',
                                                                img: "/images/CBAC.svg",
                                                                title: "CBAC",
                                                                onClick: handelCbacClick
                                                            });
                                                        }

                                                        if (permissions.some(p => ['personal_examination', 'personal_history', 'hypertension', 'diabetes', 'oral_screening', 'breast_screening', 'cervical_screening'].includes(p.form_name))) {
                                                            availableOptions.push({
                                                                key: 'screening',
                                                                img: "/images/hand.svg",
                                                                title: "Screening",
                                                                onClick: handleScreeningClick
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'Followup dt')) {
                                                            availableOptions.push({
                                                                key: 'followup',
                                                                img: "/images/follow-up.svg",
                                                                title: "Add Treatment/Follow-up",
                                                                onClick: handleFollowupClick
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'cbac')) {
                                                            availableOptions.push({
                                                                key: 'addmember',
                                                                img: "/images/add-member.svg",
                                                                title: "Add member",
                                                                onClick: handleMemberClick
                                                            });
                                                        }

                                                        return availableOptions.map(option => (
                                                            <div className="col-md-4 text-center" key={option.key}>
                                                                <div>
                                                                    <a
                                                                        href="#"
                                                                        className="cback_text"
                                                                        onClick={(event) => {
                                                                            event.preventDefault();
                                                                            option.onClick();
                                                                        }}
                                                                    >
                                                                        <img src={option.img} alt={`${option.title} Logo`} />
                                                                        <h4>{option.title}</h4>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        ));
                                                    })()
                                                    }
                                                </>
                                            ) : (
                                                <div className="col-md-12 text-center">
                                                    You are not logged in with NCD program. Please login !
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}


                {showMoModal && (
                    <>
                        <div
                            className="modal fade show d-block verificationModel"
                            id="exampleModal"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                            style={{ background: "rgba(0,0,0,0.5)" }}
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header border-bottom-0 ">
                                        <div className="text-center headerText">
                                            <h5 className="modal-title" id="exampleModalLabel">Please select an assessment for the patient:</h5>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => setShowMoModal(false)}
                                        />
                                    </div>
                                    <div className="modal-body" style={{ padding: '0px 30px' }}>
                                        <div className="row">
                                            {localStorage.getItem("NCD_token") ? (
                                                <>
                                                    {(() => {
                                                        const moOptions = [];

                                                        if (hasPermission(permissions, 'personal_examination')) {
                                                            moOptions.push({
                                                                key: 'initialassessment',
                                                                img: "/images/PERSONAL-EXAMINATION.png",
                                                                title: "Initial Assessment",
                                                                screeningstatus: '',
                                                                onClick: handleInitialAssessmentClick
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'personal_examination')) {
                                                            moOptions.push({
                                                                key: 'Hypertension',
                                                                img: "/images/bp_readings.png",
                                                                title: "Hypertension",
                                                                screeningstatus: ncdScreenDetails?.[500]?.overAllStatus ?? ncdScreenDetails?.[500]?.portalStatus,
                                                                onClick: handleHypertensionFollowupClick
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'personal_examination')) {
                                                            moOptions.push({
                                                                key: 'Diabetes',
                                                                img: "/images/el_diabetes.png",
                                                                title: "Diabetes",
                                                                screeningstatus: ncdScreenDetails?.[600]?.overAllStatus ?? ncdScreenDetails?.[600]?.portalStatus,
                                                                onClick: () => handleDiabetesFollowupClick('Diabetes')
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'personal_examination')) {
                                                            moOptions.push({
                                                                key: 'OralCancer',
                                                                img: "/images/oral-screening.png",
                                                                title: "Oral Cancer",
                                                                screeningstatus: ncdScreenDetails?.[100]?.overAllStatus ?? ncdScreenDetails?.[100]?.portalStatus,
                                                                onClick: () => handleDiabetesFollowupClick('OralCancer')
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'personal_examination') && profileData?.gender?.trim().toLowerCase() === "female") {
                                                            moOptions.push({
                                                                key: 'BreastCancer',
                                                                img: "/images/breast-screening.png",
                                                                title: "Breast Cancer",
                                                                screeningstatus: ncdScreenDetails?.[200]?.overAllStatus ?? ncdScreenDetails?.[200]?.portalStatus,
                                                                onClick: () => handleDiabetesFollowupClick('BreastCancer')
                                                            });
                                                        }

                                                        if (hasPermission(permissions, 'personal_examination') && profileData?.gender?.trim().toLowerCase() === "female") {
                                                            moOptions.push({
                                                                key: 'CervicalCancer',
                                                                img: "/images/cervical-screening.png",
                                                                title: "Cervical Cancer",
                                                                screeningstatus: ncdScreenDetails?.[300]?.overAllStatus ?? ncdScreenDetails?.[300]?.portalStatus,
                                                                onClick: () => handleDiabetesFollowupClick('CervicalCancer')
                                                            });
                                                        }

                                                        return moOptions.map(option => (
                                                            <div className="col-md-4 text-center" key={option.key}>
                                                                <div>
                                                                    <a
                                                                        href="#"
                                                                        className="cback_text"
                                                                        onClick={(event) => {
                                                                            event.preventDefault();
                                                                            option.onClick();
                                                                        }}
                                                                    >
                                                                        <img src={option.img} alt={`${option.title} Logo`} style={{ width: "100px", height: "100px", objectFit: "contain", margin: "20px auto 10px auto", display: "block" }} />
                                                                        <h4>{option.title}
                                                                            {option.screeningstatus && (
                                                                                <p style={{ color: "green", fontWeight: "600" }}>{option.screeningstatus}</p>
                                                                            )}
                                                                        </h4>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        ));
                                                    })()
                                                    }
                                                </>
                                            ) : (
                                                <div className="col-md-12 text-center">
                                                    You are not logged in with NCD program. Please login !
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </div>

            <div className="footer">
                <p>
                    © All rights reserved by Ministry of Health & Family Welfare,
                    Government of India.
                </p>
            </div>

            <LoginRequiredModal
                show={showLoginModal}
                onClose={() => setShowLoginModal(false)}
            />

        </>
    );
};